export const emailRegex = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim;
export const noNumberRegex = /^([^0-9]*)$/;

export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const FAIL = '_FAIL';



// WEBPACK FOOTER //
// ./src/shared/utils/constants.js